<template>
	<div class="columns">
		<div class="column" style="text-align: center;" v-show="state === 0">
			<div>本日のシフトはありません</div>
		</div>
		
		<div class="column" style="text-align: center;" v-show="state === 1">
			<div>出勤前報告がありません</div>
		</div>
		
		<div class="column" v-show="state === 2">
			<img class="face-preview" v-show="selfy" :src="selfy">

			<div class="has-text-centered mt-20 mb-30" v-show="selfy">
				<label>
					<a class="button is-link" ref="retakeBtn">
						<span class="icon">
							<i class="fas fa-camera"></i>
						</span>
						<span>撮り直す</span>
					</a>
					<input class="" type="file" @change="onIconChange" style="display:none;">
				</label>
			</div>

			<button type="button" class="btn" @click="onStartClick">出勤</button>
		</div>

		<div class="column" v-show="state === 3 || state === 5">
			<button type="button" class="btn" @click="onRestStartClick">休憩開始</button>
		</div>
		
		<div class="column" v-show="state === 4">
			<button type="button" class="btn" @click="onRestEndClick">休憩終了</button>
		</div>
		
		<div class="column mt-20" v-show="state === 3 || state === 5">
			<button type="button" class="btn" @click="onEndClick">退勤</button>
		</div>
		
		<div class="column" style="text-align: center;" v-show="state === 6">
			<div class="mb-20">退勤登録が完了しました</div>

			<div v-if="nextWork !== null">
				<div class="mb-10">【次回シフト情報】</div>
				<div>{{ nextWork.shop }}</div>
				<div>{{ `${nextWork.date} ${nextWork.start} ～ ${nextWork.end}` }}</div>
			</div>

			<div v-else>
				<div>次回のシフトは決まっていません</div>
			</div>

			<button v-show="!isNextWorkConfirmed" type="button" class="button is-link mt-20" @click="onNextWorkConfirm">確認しました</button>
		</div>
		
		<div class="column mt-30" style="text-align: center;" v-show="!hasReport">
			<div>
				<select class="template-select mb-20" v-if="templates.length > 0" v-model="selectedTemplate" @change="onTemplateChange">
					<option value="">日報テンプレート</option>
					<option v-for="(template, index) in templates" :key="index" :value="index">{{ template.title }}</option>
				</select>
			</div>

			<div>
				<textarea v-model="report"></textarea>
			</div>

			<button type="button" class="button report is-link mt-20" @click="onReportClick">日報登録</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'TimeCard',
	components: {
	},
	data() {
		return {
			selfy: '',
			state: 1,
			hasReport: false,
			selectedTemplate: '',
			templates: [],
			nextWork: null,
			report: '',
			isNextWorkConfirmed: false,
			isAi: false,
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onIconChange: function(e) {
			var files = e.target.files;
			if (!files.length) {
				return;
			}

			if (files[0].type.match(/jpg|jpeg|png/) === null) {
				alert('画像ファイルを選択してください');
				return false;
			}

			var reader = new FileReader();
			reader.onload = (e) => {
				this.selfy = e.target.result;
			};
			reader.readAsDataURL(files[0]);
		},
		onStartClick: function() {
			if (this.isAi && !this.selfy) {
				this.$refs.retakeBtn.click();
			} else {
				this.clock(2);
			}
		},
		onRestStartClick: function() {
			this.clock(3);
		},
		onRestEndClick: function() {
			this.clock(4);
		},
		onEndClick: function() {
			this.clock(5);
		},
		clock: async function(type) {
			let typeStr = '';
			switch (type) {
				case 2:
					typeStr = '出勤';
					break;
				case 3:
					typeStr = '休憩開始';
					break;
				case 4:
					typeStr = '休憩終了';
					break;
				case 5:
					typeStr = '退勤';
					break;
				default:
					break;
			}

			if (!window.confirm(typeStr + '登録します。よろしいですか？')) {
				return false;
			}
			this.$utils.toggleLoading();

			let data = {
				"type": type,
			};

			if (type === 2) {
				data.selfy = this.selfy;
			}
			this.$utils.log(data);

			let ep = 'time-cards/clock';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error);
				if (error.response.status === 400) {
					alert(error.response.data.message);
				} else {
					this.$utils.toastError(error.response.data.message);
				}
			} finally {
				this.$utils.toggleLoading();
			}
		},
		onTemplateChange: function() {
			this.report = this.selectedTemplate !== '' ? this.templates[this.selectedTemplate].body : '';
		},
		onNextWorkConfirm: async function() {
			if (!window.confirm('次のシフトを確認しましたか？')) {
				return false;
			}
			this.$utils.toggleLoading();

			let data = {
			};
			this.$utils.log(data);

			let ep = 'works/confirm-next-work';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.$utils.toggleLoading();
			}
		},
		onReportClick: async function() {
			if (!window.confirm('日報を登録します。よろしいですか？')) {
				return false;
			}
			this.$utils.toggleLoading();

			let data = {
				"report": this.report,
			};
			this.$utils.log(data);

			let ep = 'works/report';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.$utils.toggleLoading();
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function(current) {
			this.$utils.toggleLoading();

			let ep = 'time-cards'
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.state = res.data.state;
				this.hasReport = res.data.has_report;
				this.templates = res.data.templates;
				this.isNextWorkConfirmed = res.data.is_next_work_confirmed;
				this.isAi = res.data.is_ai;

				if (Object.keys(res.data.next_work).length > 0) {
					this.nextWork = res.data.next_work;
				}

			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.$utils.toggleLoading();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.columns {
	padding: 10px 10% 30px;
}
.btn {
	display: block;
	width: 100%;
}
.report {
	width: 100px;
	margin: 0 auto;
}

textarea {
	width: 100%;
	height: 180px;
	padding: 10px 5px;
	font-size: 14px;
	-webkit-overflow-scrolling: touch;
}

.template-select {
	width: 100%;
	height: 30px;
	font-size: 14px;
}

.face-preview {
	width: 130px;
	height: auto;
	border: 1px #ccc solid;
	border-radius: 5px;
	margin: 0 auto;
	display: block;
}

</style>
